import { Box } from "@chakra-ui/react";
import { FC } from "react";

import { Tab, TabProps } from "~/src/components/common/Tab";
import { PageLayout } from "~/src/components/features/global/PageLayout";
import { chakraFactory } from "~/src/lib/chakra-ui";

export type Props = {
  tabs: TabProps["tabs"];
  currentTabId: "bulk_new" | "bulk_edit";
  onTabChange: (tab: Props["tabs"][0]["id"]) => void;
};

const StyledTab = chakraFactory(Tab, {
  baseStyle: {
    mt: "10px",
  },
});

export const FunnelBulkPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, tabs, currentTabId, onTabChange }) => (
  <PageLayout title="ファネル一括管理">
    <Box mt="10px">
      <StyledTab
        tabs={tabs}
        currentTabId={currentTabId}
        onClick={onTabChange}
      />
      {children}
    </Box>
  </PageLayout>
);
